import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { GalleryModalService } from '../gallery-modal.service';

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GalleryModalComponent {
  constructor(
    public readonly galleryModalService: GalleryModalService,
    private readonly sanitizer: DomSanitizer
  ) {}

  public getSafeImageUrl(link: string | null | undefined): string | SafeUrl | null {
    if (!link) {
      return null;
    }

    if (link.startsWith('blob:')) {
      return this.sanitizer.bypassSecurityTrustUrl(link);
    }

    return link;
  }

  @HostListener('window:keydown.escape', ['$event'])
  public handleEscKey() {
    if (!this.galleryModalService.isOpen) {
      return;
    }

    this.galleryModalService.close();
  }

  @HostListener('window:keydown.arrowleft', ['$event'])
  public handleLeftKey() {
    if (!this.galleryModalService.isOpen) {
      return;
    }

    this.galleryModalService.Prev();
  }

  @HostListener('window:keydown.arrowright', ['$event'])
  public handleRightKey() {
    if (!this.galleryModalService.isOpen) {
      return;
    }

    this.galleryModalService.Next();
  }
}
